// extracted by mini-css-extract-plugin
export default {"cardBrandCell":"SpecialCells_cardBrandCell__hm6Rz","paymentMethodCell":"SpecialCells_paymentMethodCell__fcGhI"};